import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import tables from "../../../../Data/Tables/Customers/Statement/tables";
import headers from "../../../../Data/Tables/Customers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
import UserCurrency from "../../../../Componets/UserCurrency";
import jsPDF from "jspdf";
import { Button } from "antd";
import { registerCairoFont } from "../../../Reports/cairo-font";
import autoTable from "jspdf-autotable";
import { get_user_auth } from "../../../../Controllers/Layouts/Layouts";

const CustomerOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalInvoices: 0,
    overdueAmount: 0,
  });
  const [customerName, setCustomerName] = useState("");
  const [authorizeMail, setAuthorizeMail] = useState(false);
  const { id } = useParams();
  localStorage.setItem("Customer_Id", id);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment_status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateOutstanding = (invoice) => {
    const total = invoice.total || 0;
    const paid =
      invoice.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
    return total - paid;
  };

  const fetchSummary = async () => {
    try {
      const params = {
        customer: id,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        const invoices = response?.data?.data || [];
        let totalOutstanding = 0;
        let overdueAmount = 0;

        invoices.forEach((invoice) => {
          setCustomerName(invoice.customer?.name || "N/A");
          const outstanding = calculateOutstanding(invoice);
          totalOutstanding += outstanding;

          if (invoice.due_date && outstanding > 0) {
            if (new Date(invoice.due_date) < new Date()) {
              overdueAmount += outstanding;
            }
          }
        });

        setSummary({
          totalOutstanding,
          totalInvoices: response?.data?.totalCount || invoices.length,
          overdueAmount,
        });
      } else {
        toast.error("Failed to fetch summary");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        customer: id,
        search: tabledata?.search,
        payment: tabledata?.payment,
        delivery_status: tabledata?.delivery_status,
        date: tabledata?.date,
        page: tabledata?.currentPage,
        limit: 10,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        let invoices = response?.data?.data || [];

        invoices = invoices.filter(
          (invoice) => calculateOutstanding(invoice) > 0,
        );

        const startIndex = ((params.page || 1) - 1) * params.limit;
        const paginatedInvoices = invoices.slice(
          startIndex,
          startIndex + params.limit,
        );

        const tableData = paginatedInvoices.map((invoice) => {
          const outstanding = calculateOutstanding(invoice);

          return {
            path: `/app/billing/view/${invoice?._id}`,
            "Invoice No": `#${invoice.number}`,
            Date: <DateTimeBadge date={invoice?.date} />,
            "Due Date": invoice.due_date ? (
              <DateTimeBadge date={invoice?.due_date} />
            ) : (
              "-"
            ),
            "Total Amount": (
              <>
                {" "}
                <UserCurrency /> {invoice.total?.toFixed(3)}{" "}
              </>
            ),
            "Paid Amount": invoice.payments?.length
              ? invoice.payments
                  .map((p) => `${p.name}: ${p.amount.toFixed(3)}`)
                  .join(", ")
              : "0.000",
            Outstanding: (
              <>
                <UserCurrency /> {outstanding.toFixed(3)}
              </>
            ),
            "Payment Status":
              invoice?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : invoice?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            "Delivery Status":
              invoice?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : invoice?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: invoices.length,
          totalPages: Math.ceil(invoices.length / params.limit),
        });
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const fetchAuthorizeUser = async () => {
    try {
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email =
          response?.data?.branch?.plan === 3000 &&
          response?.data?.email?.trim().toLowerCase() ===
            process.env.REACT_APP_CROWN_PHARMACY_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch User Auth");
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  const fetchAllInvoices = async () => {
    try {
      const headerdata = {};
      header?.components?.forEach((value) => {
        headerdata[value.name] = value.value;
      });

      const params = {
        customer: id,
        search: headerdata?.search,
        payment: headerdata?.payment_status,
        date: headerdata?.date,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        return (response?.data?.data || []).filter(
          (inv) => calculateOutstanding(inv) > 0,
        );
      }

      return [];
    } catch (error) {
      toast.error("Failed to fetch invoices");
      return [];
    }
  };

  const downloadCSV = async () => {
    try {
      const invoices = await fetchAllInvoices();

      if (!invoices.length) {
        toast.error("No data available");
        return;
      }

      const headers = [
        "S.No",
        "Invoice No",
        "Customer",
        "Date",
        "Due Date",
        "Total",
        "Paid",
        "Outstanding",
        "Payment Status",
        "Delivery Status",
      ];

      const rows = invoices.map((inv, index) => {
        const outstanding = calculateOutstanding(inv);

        const paid =
          inv.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;

        return [
          index + 1,
          inv.number,
          inv.customer?.name || "N/A",
          inv.date ? new Date(inv.date).toLocaleDateString("en-GB") : "",
          inv.due_date
            ? new Date(inv.due_date).toLocaleDateString("en-GB")
            : "",
          inv.total?.toFixed(3),
          paid.toFixed(3),
          outstanding.toFixed(3),
          inv.payment_status === 2
            ? "Paid"
            : inv.payment_status === 1
              ? "Partial"
              : "Unpaid",
          inv.delivery_status === 2
            ? "Delivered"
            : inv.delivery_status === 1
              ? "Partial"
              : "Pending",
        ].join(",");
      });

      const csv = [headers.join(","), ...rows].join("\n");

      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Customer_Statement_${new Date()
        .toLocaleDateString()
        .replace(/\//g, "_")}.csv`;

      link.click();
    } catch (err) {
      toast.error("CSV download failed");
    }
  };

  const downloadPDF = async () => {
    try {
      const invoices = await fetchAllInvoices();

      if (!invoices.length) {
        toast.error("No data available");
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);

      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(18);
      doc.text(
        `Customer Outstanding Report - ${customerName}`,
        pageWidth / 2,
        18,
        { align: "center" },
      );

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString();
      doc.setFontSize(10);
      doc.text(
        `Downloaded on: ${formattedDate} ${formattedTime}`,
        pageWidth / 2,
        26,
        { align: "center" },
      );

      const rows = invoices.map((inv, index) => {
        const outstanding = calculateOutstanding(inv);

        const paid =
          inv.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;

        return [
          index + 1,
          inv.number,
          inv.date ? new Date(inv.date).toLocaleDateString("en-GB") : "-",
          inv.due_date
            ? new Date(inv.due_date).toLocaleDateString("en-GB")
            : "-",
          inv.total?.toFixed(3),
          paid.toFixed(3),
          outstanding.toFixed(3),
          inv.payment_status === 2
            ? "Paid"
            : inv.payment_status === 1
              ? "Partial"
              : "Unpaid",
          inv.delivery_status === 2
            ? "Delivered"
            : inv.delivery_status === 1
              ? "Partial"
              : "Pending",
        ];
      });

      autoTable(doc, {
        startY: 32,
        head: [
          [
            "S.No",
            "Invoice No",
            "Date",
            "Due Date",
            "Total",
            "Paid",
            "Outstanding",
            "Payment",
            "Delivery",
          ],
        ],
        body: rows,
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [222, 222, 222],
          fillColor: false,
          lineWidth: 0.2,
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [222, 222, 222],
          lineWidth: 0.2,
        },
        alternateRowStyles: {
          fillColor: false,
        },
      });

      doc.save("Customer_Statement.pdf");
    } catch (err) {
      toast.error("PDF download failed");
    }
  };

  useEffect(() => {
    if (id) {
      fetchSummary();
      fetchData();
      headerReset();
    }
  }, [id]);

  useEffect(() => {
    fetchAuthorizeUser();
  }, []);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 mt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              <UserCurrency /> {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Invoices</h3>
            <p className="text-green-600">{pagination.totalCount}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              <UserCurrency /> {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>

        {authorizeMail && (
          <div className="flex gap-3 justify-end mt-4">
            <Button type="primary" onClick={downloadCSV}>
              Download CSV
            </Button>

            <Button type="primary" onClick={downloadPDF}>
              Download PDF
            </Button>
          </div>
        )}

        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default CustomerOutstandingStatement;
